export default __webpack_public_path__ + "static/banner-are-you-financially-responsible-1689d0cbe40496e01701027f727f75cb.jpg";